import { OFFICE_CLOSED } from '@/config/constants'

export default function state() {
	return {
		officeOpenInfo: {
			active: false,
			indicator: OFFICE_CLOSED,
			visible: true,
		},
	}
}
